import React from 'react';
import { OptionFormTypes } from './option-form-types';
import { FormContains } from './form-types/form-contains';
import { FormString } from './form-types/form-string';
import { FormNumberComparison } from './form-types/form-number-comparison';
import { FormDateComparison } from './form-types/form-date-comparison';
import { FormIsOptions } from './form-types/form-is-options';
import { FormIsRadioOptions } from './form-types/form-is-radio-options';
import { FormIsFreeInput } from './form-types/form-is-free-input';
import { FormChecklist } from './form-types/form-checklist';
import { FormIsMultiOption } from './form-types/form-is-multi-options';
import { MM_DD_YYYY } from '../../../constants/date-format';

const filterBarDateFormat = MM_DD_YYYY;

export const renderFormBasedOnType = (optionFormType, criteriaInformations, existingFiltersHelpers) => {
  const { selectedFilterBy, criterionStateMethods, criterionOperatorOptions, criterionArgumentOptions } = criteriaInformations;
  switch (optionFormType) {
    case OptionFormTypes.TYPE_CONTAINS:
      return FormContains(criterionStateMethods, criterionOperatorOptions);
    case OptionFormTypes.TYPE_STRING:
      return FormString(criterionStateMethods, criterionOperatorOptions);
    case OptionFormTypes.TYPE_NUMBER_COMPARISON:
    case OptionFormTypes.TYPE_CURRENCY_COMPARISON:
      // TODO: Use FormCurrencyComparison when we support filtering on specific currency types
      return FormNumberComparison(criterionStateMethods, criterionOperatorOptions);
    case OptionFormTypes.TYPE_DATE_COMPARISON_DEPRECATED: // TODO: Remove when no longer in use per SPD-1623 - Greg S 1/10/20:
    case OptionFormTypes.TYPE_ORDER_DATE_COMPARISON:
    case OptionFormTypes.TYPE_DATE_COMPARISON:
    case OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS:
      return (
        <FormDateComparison
          criterionOperatorOptions={criterionOperatorOptions}
          criterionStateMethods={criterionStateMethods}
          dateFormatString={filterBarDateFormat}
        />
      );
    case OptionFormTypes.TYPE_IS_OPTIONS:
      return FormIsOptions(criterionStateMethods, criterionArgumentOptions, selectedFilterBy);
    case OptionFormTypes.TYPE_IS_RADIO_OPTIONS:
      return FormIsRadioOptions(criterionStateMethods, criterionArgumentOptions);
    case OptionFormTypes.TYPE_IS_FREE_INPUT_DEPRECATED: // TODO: Remove when no longer in use per SPD-1566 - Greg S 1/7/20:
      return FormIsFreeInput(criterionStateMethods);
    case OptionFormTypes.TYPE_CHECKLIST:
      return FormChecklist(criterionArgumentOptions, selectedFilterBy, existingFiltersHelpers);
    case OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS:
    case OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER:
    case OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK:
      return FormIsMultiOption(criteriaInformations, existingFiltersHelpers.existingFilters);
    default:
      return <div>Invalid Filter Specification</div>;
  }
};
